<template>
  <v-main>
    <v-container v-if="!loading">
      <v-toolbar class="elevation-0 mb-3 b-sm-0">
        <div class="pl-0 ml-n4 d-flex align-start align-sm-center flex-column flex-sm-row">
          <span class="headline">{{ fields.celebration.name || 'Turma não identificada' }}</span>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex mr-n4 align-center">
          <v-btn text color="primary" @click="editItemShow = true">
            <v-icon left>mdi-pencil</v-icon> Editar participante
          </v-btn>
          <v-btn text color="primary" @click="modalParticipantReport = true">
            <v-icon left>mdi-printer</v-icon> Imprimir Relatório
          </v-btn>
          <v-btn @click="copyToClipboard(id)" color="primary" fab text small dark>
            <v-icon>mdi-code-tags</v-icon>
          </v-btn>
        </div>
      </v-toolbar>
      <div class="mb-2 mt-n4">
        <span class="title">{{ fields.customer.name || 'Cliente sem nome' }} ({{ fields.customer.nickname || 'Sem Apelido' }})</span>
        <v-chip class="ml-sm-2" small :color="(fields.role === 'participant') ? 'primary' : 'secondary'">{{ fields.role | role }}</v-chip>
      </div>
      <div class="d-flex justify-start align-start flex-column flex-sm-row">
        <div class="mr-auto">
          <small>CPF/CNPJ</small>
          <br>
          <b>{{ fields.customer.person_document | document }}</b>
          <br>
          <small>Telefone</small>
          <br>
          <b>{{ fields.customer.phone_number | phone_number }}</b>
          <br>
          <small>E-mail</small>
          <br>
          <b>{{ fields.customer.email }}</b>
        </div>
        <div class="mr-auto mt-4 mt-sm-0">
          <small>Dia de pagamento</small>
          <br>
          <b>{{ (fields.payment_day === 0) ? 'Último dia' : 'Dia ' + fields.payment_day }}</b>
          <br>
          <small>Entrou em</small>
          <br>
          <b>{{ fields.created_at | moment('DD/MM/YYYY hh:mm:ss') }}</b>
        </div>
        <participant-document-status :celebrationId="fields.celebration.id" :email="fields.customer.email" :participantId="id" :participantName="fields.customer.name" />
        <!--div>
          <div class="no-wrap mt-4 mt-sm-0 ml-sm-5">
            <small>Meta geral</small>
            <br>
            <span class="title">{{ fields.goal | price }}</span>
          </div>
          <div class="d-flex no-wrap mt-4 mt-sm-0">
            <div class="ml-sm-5">
              <small>Total Pago</small>
              <br>
              <span class="title">{{ fields.total_paid | price }}</span>
            </div>
            <div class="ml-5">
              <small>Total Atrasado</small>
              <br>
              <span class="title">{{ fields.total_late | price }}</span>
            </div>
          </div>
        </div-->
      </div>
      <br>
      <v-tabs
        v-model="tab"
        center-active
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab key="tab-notes" href="#tab-notes">Anotações</v-tab>
        <v-tab key="tab-fundraisings" href="#tab-fundraisings">Arrecadações</v-tab>
        <v-tab key="tab-invoices" href="#tab-invoices">Faturas</v-tab>
        <v-tab key="tab-renegotiations" href="#tab-renegotiations">Renegociações</v-tab>
        <v-tab key="tab-tickets" href="#tab-tickets">Chamados</v-tab>

        <v-tab-item key="tab-item-notes" value="tab-notes">
          <v-tabs v-model="tabNotes" center-active>
            <v-tabs-slider></v-tabs-slider>
            <v-tab key="tab-notes-participants" href="#tab-notes-participants">Participante</v-tab>
            <v-tab key="tab-notes-celebrations" href="#tab-notes-celebrations">Turma</v-tab>
            <v-tab-item key="tab-item-notes-participants" value="tab-notes-participants">
              <notes reference="participant" :customerId="fields.customer.id" :celebrationId="fields.celebration.id" :participantId="id"></notes>
            </v-tab-item>
            <v-tab-item key="tab-item-notes-celebrations" value="tab-notes-celebrations">
              <notes reference="celebration" :celebrationId="id"></notes>
            </v-tab-item>
          </v-tabs>
        </v-tab-item>

        <v-tab-item key="tab-item-fundraisings" value="tab-fundraisings">
          <participant-details-fundraisings type="fundraisings" :celebration-id="fields.celebration.id" :participant-id="id" :parcial-info="fields.fundraisings" @edited="getData()"></participant-details-fundraisings>
        </v-tab-item>

        <v-tab-item key="tab-item-invoices" value="tab-invoices">
          <invoices :customer-id="fields.customer.id" :celebration-id="fields.celebration.id"></invoices>
        </v-tab-item>

        <v-tab-item key="tab-item-renegotiations" value="tab-renegotiations">
          <renegotiations :joineds="fields.fundraisings"></renegotiations>
        </v-tab-item>

        <v-tab-item key="tab-item-tickets" value="tab-tickets">
          <v-tabs v-model="tabTickets" center-active>
            <v-tabs-slider></v-tabs-slider>
            <v-tab key="tab-asana" href="#tab-asana">Asana</v-tab>
            <v-tab key="tab-huggy" href="#tab-huggy">Huggy</v-tab>
            <v-tab-item key="tab-item-asana" value="tab-asana">
              <ticket-list reference="participant" :id="id" :asanaID="asanaID"></ticket-list>
            </v-tab-item>
            <v-tab-item key="tab-item-huggy" value="tab-huggy">
              <huggy-list reference="participant" :id="id" :customerID="fields.customer.id"></huggy-list>
            </v-tab-item>
          </v-tabs>
        </v-tab-item>
      </v-tabs>
    </v-container>
    <app-loading :visible="loading"></app-loading>
    <edit-modal
      :id="id"
      :item="fields"
      v-if="editItemShow"
      @canceled="editItemShow = false"
      @error="editItemShow = false"
      @edited="editItemShow = false; getData()"
    ></edit-modal>
    <v-dialog v-model="modalParticipantReport" max-width="400">
      <v-card>
        <v-card-title class="headline">Gerar relatório</v-card-title>
        <v-card-text>
          <p>Você pode alterar o nome do documento se desejar:</p>
          <v-form ref="form" @submit.prevent>
            <v-text-field
              label="Nome do documento"
              v-model="report.title"
              outlined dense
            ></v-text-field>
            <p>O que deseja que tenha nele?</p>
            <v-checkbox
              label="Dados cadastrais"
              v-model="report.info"
              color="primary"
              style="margin-top: -10px"
            ></v-checkbox>
            <v-checkbox
              label="Totais das Arrecadações que ele participa"
              v-model="report.fundraisings"
              color="primary"
              style="margin-top: -10px"
            ></v-checkbox>
            <v-checkbox
              label="Faturas pagas"
              v-model="report.paid"
              color="primary"
              style="margin-top: -10px"
            ></v-checkbox>
            <v-checkbox
              label="Faturas em aberto (atrasadas e em aberto)"
              v-model="report.pending"
              color="primary"
              style="margin-top: -10px"
            ></v-checkbox>
            <v-checkbox
              label="Próximas faturas"
              v-model="report.next"
              color="primary"
              style="margin-top: -10px"
            ></v-checkbox>
            <v-checkbox
              label="Observações (campos de anotações)"
              v-model="report.notes"
              color="primary"
              style="margin-top: -10px"
            ></v-checkbox>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="modalParticipantReport = false">
            Fechar
          </v-btn>
          <v-btn
            color="success"
            :disabled="!report.info && !report.fundraisings && !report.paid && !report.pending && !report.next && !report.notes"
            text
            :to="{
              name: 'participantPrint',
              params: { id },
              query: {
                title: report.title,
                info: report.info,
                fundraisings: report.fundraisings,
                paid: report.paid,
                pending: report.pending,
                next: report.next,
                notes: report.notes
              }
            }"
          >
            Gerar documento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapActions, mapMutations } from 'vuex'
import AppLoading from '@/components/Loading'
import EditModal from '@/components/EditModals/Participant'
import ParticipantDetailsFundraisings from '@/components/ParticipantDetailsFundraisings'
import Invoices from '@/views/Invoices/Invoices'
import Renegotiations from '@/views/Renegotiations/Renegotiations'
import Notes from '@/components/NoteList'
import TicketList from '@/components/TicketTabList'
import HuggyList from '@/components/HuggyTabList'
import ParticipantDocumentStatus from '@/components/ParticipantDocumentStatus'

export default {
  name: 'participantForm',
  components: {
    AppLoading,
    EditModal,
    ParticipantDetailsFundraisings,
    Invoices,
    Renegotiations,
    Notes,
    TicketList,
    HuggyList,
    ParticipantDocumentStatus
  },
  props: ['id'],
  data: () => ({
    loading: false,
    tab: 'tab-notes',
    tabNotes: 'tab-notes-participant',
    tabTickets: 'tab-asana',
    fields: {
      customer: {
        id: '',
        name: '',
        nickname: '',
        email: '',
        phone_number: '',
        person_document: ''
      },
      celebration: {
        id: '',
        name: ''
      },
      payment_day: 0,
      role: '',
      goal: 0,
      total_late: 0,
      total_paid: 0,
      created_at: '',
      fundraisings: []
    },
    asanaID: '',
    editItemShow: false,
    modalParticipantReport: false,
    report: {
      title: 'Ficha Financeira',
      info: false,
      fundraisings: false,
      paid: false,
      pending: false,
      next: false,
      notes: false
    }
  }),
  watch: {
    modalParticipantReport (val) {
      if (val) {
        this.report.title = 'Ficha Financeira'
        this.report.info = false
        this.report.fundraisings = false
        this.report.paid = false
        this.report.pending = false
        this.report.next = false
        this.report.notes = false
      }
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    ...mapActions(['copyToClipboard']),
    getData () {
      let vue = this
      vue.loading = true

      axios.get('participants/' + vue.id)
        .then(response => {
          if (response.data) {
            vue.loading = false
            for (let key in vue.fields) {
              if (response.data[key]) vue.fields[key] = response.data[key]
            }

            if (vue.fields.celebration && vue.fields.celebration.id) {
              this.$firestore.collection('settings').doc(vue.fields.celebration.id).get()
                .then((snapshot) => {
                  const data = snapshot.data()
                  this.asanaID = (data && data.asana) || null
                })
            }
          } else {
            vue.loading = false
            vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
            vue.$router.go(-1)
          }
        })
        .catch(() => {
          vue.loading = false
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.$router.go(-1)
        })
    }
  },
  created () {
    if (this.id) {
      this.getData()
    }
  }
}
</script>
